import React from 'react';
import ComingSoon from './ComingSoon';

function Support() {
  return <ComingSoon />;
}

export default Support;
